// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"3e48a029","38":"9a1b3123","453":"46dc3e92","884":"0ec73844","921":"61c2d7df"}[chunkId] + ".chunk.js";
};